import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, className = "", delay = 0, inView = false, play = true }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.15 } }
    : { animate: play ? "show" : "hidden" };
  return (
    <motion.span
      className={`block ${className}`}
      initial="hidden"
      {...trigger}
      variants={{ show: { transition: { staggerChildren: 0.12, delayChildren: delay } } }}
    >
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className="block"
            variants={{ hidden: { y: "105%" }, show: { y: "0%", transition: { duration: 1.1, ease: EASE } } }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const ParallaxImage = ({ src, alt, className = "", strength = 60, testId, imgClassName = "object-cover", overscan = 12 }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [-strength, strength]);
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`} data-testid={testId}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y, top: `-${overscan}%`, height: `${100 + overscan * 2}%` }}
        className={`absolute inset-x-0 w-full will-change-transform ${imgClassName}`}
      />
    </div>
  );
};

export { EASE };
